import { Component, input } from '@angular/core';
import { WinCardSecondVariantConfig } from '@shared/models';
import { AmountPipe, SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant2',
  styleUrl: './variant2.component.scss',
  templateUrl: './variant2.component.html',
  imports: [SafePipe, AmountPipe, VariableReplacementPipe],
})
export class Variant2Component {
  amount = input<number>(0);
  config = input.required<WinCardSecondVariantConfig>();
}
